import React from 'react';

function Download() {
  const openLink = (url) => {
    const tg = window.Telegram?.WebApp;
    if (tg) {
      tg.openLink(url);
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <div className="page-container" style={{paddingTop: '60px'}}>
      <h1 className="page-title">Скачать приложение</h1>
      <p>Для использования VPN-ключей вам понадобится приложение V2RayTun.</p>
      <div className="download-links">
        <button onClick={() => openLink('https://apps.apple.com/app/v2raytun/id6476628951')} className="download-button">
          📱 Скачать для iOS
        </button>
        <button onClick={() => openLink('https://play.google.com/store/apps/details?id=com.v2raytun.android')} className="download-button">
          🤖 Скачать для Android
        </button>
        <button onClick={() => openLink('https://github.com/2dust/v2rayN/releases')} className="download-button">
          🪟 Скачать для Windows
        </button>
        <button onClick={() => openLink('https://github.com/2dust/v2rayNG/releases')} className="download-button">
          🐧 Скачать для Linux
        </button>
        <button onClick={() => openLink('https://github.com/yanue/V2rayU/releases')} className="download-button">
          🍎 Скачать для macOS
        </button>
      </div>
    </div>
  );
}

export default Download; 